<template>
  <div class="section" id="liveExplore">
    <div class="container">
      <div class="columns is-fluid">
        <div class="column">
          <h1 class="subtitle">配信一覧</h1>

          <div class="container is-fluid">
            <div class="columns is-multiline">
              <div
                class="column is-one-quarter"
                v-for="(item, index) in lives"
                :key="index"
              >
                <router-link :to="`/live/streaming/${item.id}`">
                  <div class="thumbnail">
                    <img class="thumbnail-image" :src="item.thumbnailUrl" />
                  </div>
                  <div class="live-description">
                    <p class="is-size-6">{{ item.title }}</p>
                    <p class="is-size-7">{{ item.startAt }}</p>
                    <p class="is-size-7">{{ item.aboutLive }}</p>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as liveServices from '@/services/liveServices';
import * as authServices from '@/services/authServices';

export default {
  name: 'LiveExplore',
  data() {
    return {
      lives: []
    };
  },
  async created() {
    console.log('entered');
    if (
      !authServices.getFirebaseUser().emailVerified &&
      !this.$route.path.includes('signup')
    ) {
      this.$router.push('/user/created');
    }
    this.lives = await liveServices.getAllRecentLives();
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/live-explore.scss';
#liveExplore {
  min-height: 1000px;
}
.live-description {
  margin-top: auto;
}
</style>
